import React, { useEffect, useState } from "react";
import "./CancelOrder.css";
import Header from "../../../../Layout/Header/Header";
import Footer from "../../../../Layout/Footer/Footer";
import { useDispatch } from "react-redux";
import {
  getAllOrderListAPI,
  getAllOrderStatusAPI,
  updateOrderStatusAPI,
} from "../../../../../../Store/Action/orderAction";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomCancellationReturnPolicyModal from "../../../../CustomComponents/CustomCancellationReturnPolicyModal";
import Icons from "../../../../../../Config/Images";
import { UploadMediaRequestAPI } from "../../../../../../Store/Action/mediaAction";
import { toast } from "react-toastify";

const FileUpload = React.forwardRef(
  (
    {
      label,
      value,
      onChange,
      error,
      errors,
      onmouseoutFunction,
      preview,
      fileType,
      fieldKey,
    },
    ref
  ) => (
    <div className="questionsUpload" onBlur={onmouseoutFunction}>
      <p className="paraUpload">{label}</p>
      <div
        className="custom-file-upload-cancel-order"
        onClick={() => ref.current && ref.current.click()}
        style={{ position: "relative" }}
      >
        {preview?.url &&
          (preview.type === "application/pdf" ? (
            <img
              src={Icons?.default_pdf_icon} // Replace with your PDF icon path
              alt="PDF Uploaded"
              className="file-upload-preview-pdf"
            />
          ) : (
            <img
              src={preview.url}
              alt="Image Uploaded"
              className="file-upload-preview"
            />
          ))}
        <input
          type="text"
          placeholder={preview?.url ? "" : "No file chosen"}
          readOnly
          // className="file-input-text"
          className={
            errors?.[fieldKey] ? "error-input" : "file-input-text-cancel-order"
          } // Apply error class
          value={value || ""}
        />
        <input
          type="file"
          ref={ref}
          className="file-input-hidden"
          accept=".pdf,.jpg,.jpeg,.png"
          required
          onChange={onChange}
        />
        {/* {preview} */}
        <button type="button" className="browse-button-cancel-order">
          Browse
        </button>
      </div>

      {error && <div className="error">{error}</div>}
    </div>
  )
);
const CancelOrder = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const uplaodFileRef = useState(null);
  const order = location?.state?.order;
  const { orderId } = useParams();
  const fromCancelBtn = location?.state?.fromCancelBtn;

  const [formData, setFormData] = useState({});
  const [orderStatus, setOrderStatus] = useState([]);
  const [uploadedDocs, setUploadedDocs] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReason, setOtherReason] = useState(""); // For custom input
  const [isChecked, setIsChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(
      getAllOrderStatusAPI({}, (result) => {
        setOrderStatus(result);
      })
    );
  }, [dispatch]);

  const handleCancelOrder = () => {
    if (isSubmitting) return;

    // 1️⃣ Reason validation
    if (!selectedReason) {
      toast.error("Please select a reason");
      return;
    }

    // 2️⃣ Other reason validation
    if (selectedReason === "Other" && !otherReason.trim()) {
      toast.error("Please enter your reason");
      return;
    }

    // 3️⃣ FILE REQUIRED FOR RETURN
    if (!fromCancelBtn && !formData?.uploadedDocs) {
      toast.error("Please upload a supporting document for return");
      return;
    }

    // 4️⃣ Policy agreement validation
    if (!isChecked) {
      toast.error("Please agree to the Cancellation, Return & Refund Policy");
      return;
    }

    // 5️⃣ Resolve order status
    const cancelOrderstatus = orderStatus?.find(
      (os) => os?.order_status_name?.toLowerCase() === "cancel"
    );

    const returnOrderstatus = orderStatus?.find(
      (os) => os?.order_status_name?.toLowerCase() === "return"
    );

    const requestedOrderStatusId = fromCancelBtn
      ? cancelOrderstatus?.order_status_id
      : returnOrderstatus?.order_status_id;

    const requestData = {
      order_status_id: requestedOrderStatusId,
      order_id: orderId || order?.order_id,
      cancelled_resons: selectedReason,
      file_storage_id: formData?.uploadedDocs,
    };
    setIsSubmitting(true);
    dispatch(
      updateOrderStatusAPI(requestData, (result) => {
        if (result?.status) {
          // toast?.success(result?.message?.message);
          toast.success("Order updated successfully");
          navigate("/my-account/my-orders");
        } else {
          toast.error("Something went wrong. Please try again later.");
        }
        setIsSubmitting(false);
      })
    );
  };

  const handleOpenModal = (e) => {
    e.preventDefault(); // Prevent checkbox toggle
    e.stopPropagation(); // Stop event bubbling
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFileChange = (ref, fieldName) => {
    const file = ref.current?.files[0];

    if (file) {
      // Clear any previous errors
      // setErrors((prevErrors) => ({
      //   ...prevErrors,
      //   [fieldName]: "",
      // }));
    }

    const selectedFiles = [file]; // Directly use the File object

    dispatch(
      UploadMediaRequestAPI(selectedFiles, "returnOrder", false, (result) => {
        if (result.status) {
          const fileType = result?.data?.[0]?.file_storage_type || "";
          const fileUrl = result?.data?.[0]?.file_url || "";

          // Store both URL and type for preview
          const fileData = { url: fileUrl, type: fileType };

          switch (fieldName) {
            case "uploadedDocs":
              setUploadedDocs(fileData);
              break;

            default:
              break;
          }

          // Store file ID in form data
          setFormData((prev) => ({
            ...prev,
            [fieldName]: result.data[0].file_storage_id,
          }));

          // Clear any previous errors
          // setErrors((prevErrors) => ({
          //   ...prevErrors,
          //   [fieldName]: "",
          // }));
        }
      })
    );
  };
  const isButtonDisabled =
    !selectedReason ||
    !isChecked ||
    (!fromCancelBtn && !formData?.uploadedDocs);

  return (
    <>
      <Header />
      <div className="cancel-order-page-main-div">
        <div className="cancel-order-account-header">
          <h3>{fromCancelBtn ? <>Cancel</> : <>Return</>} Order</h3>
        </div>

        <div className="divider"></div>

        <div className="cancel-order-below-div">
          <p className="select-reason-p">Select a Reason</p>

          <div className="reason-container">
            {[
              "Wrong Item",
              "Item Delayed",
              "Better Price Found",
              "Change of Mind",
              "Other",
            ].map((reason, index) => (
              <label key={index} className="radio-label">
                <input
                  type="radio"
                  name="cancelReason"
                  value={reason}
                  checked={selectedReason === reason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                />
                <span>{reason}</span>
              </label>
            ))}
          </div>
          {/* Show input field if "Other" is selected */}
          {selectedReason === "Other" && (
            <div className="other-reason-container">
              <textarea
                className="other-reason-textarea"
                placeholder="Enter your reason"
                value={otherReason}
                onChange={(e) => setOtherReason(e.target.value)}
              />
            </div>
          )}
          {/* --=-- */}
          {!fromCancelBtn && (
            <>
              <FileUpload
                // label={`${
                //   formData.gstCheckbox === "No" ? "14." : "15."
                // } Could you upload your visiting card?`}
                label={<>Upload File</>}
                ref={uplaodFileRef}
                // value={formData.visitingCardFile}
                preview={uploadedDocs}
                onChange={() => handleFileChange(uplaodFileRef, "uploadedDocs")}
                // onmouseoutFunction={handleFormFieldChange}
                // error={errors.visitingCardFile}
                fieldKey="uploadedDocs"
                // errors={errors}
              />
            </>
          )}

          <div className="checked-cancellation-policies">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
              />
              <span>
                I agree to the{" "}
                <span className="link-div" onClick={handleOpenModal}>
                  Cancellation, Return & Refund Policy{" "}
                </span>{" "}
              </span>
            </label>
          </div>

          <button
            // className={`cancel-order-button ${
            //   selectedReason === "" || !isChecked ? "disabled-btnn" : ""
            // }`}
            className="cancel-order-button"
            disabled={isButtonDisabled || isSubmitting}
            onClick={handleCancelOrder}
          >
            {isSubmitting
              ? "Processing..."
              : fromCancelBtn
              ? "Confirm Cancellation"
              : "Confirm Return"}
          </button>
        </div>
      </div>
      <Footer />
      {/* Custom Modal Component */}
      <CustomCancellationReturnPolicyModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        content={
          <>
            <p>
              <strong>1. Order Cancellation Policy</strong>
            </p>
            <p>
              <strong>Before Shipment:</strong> Retailers may cancel orders
              within 24 hours of placement without penalty. For
              custom/hallmarked items, cancellations are only allowed within 6
              hours.
            </p>
            <p>
              <strong>After Shipment:</strong> Cancellations are not permitted
              once the order is dispatched.
            </p>

            <p>
              <strong>2. Return Policy</strong>
            </p>
            <p>
              <strong>Eligibility:</strong> Returns accepted only for defective,
              damaged, or misrepresented items. Must be requested within 7 days
              of delivery.
            </p>
            <p>
              <strong>Non-Returnable Items:</strong> Custom-made/hallmarked
              jewelry, "PCS Rate" or bulk-order items, loose diamonds (unless
              certification mismatch).
            </p>

            <p>
              <strong>3. Refund Policy</strong>
            </p>
            <p>
              <strong>Approved Returns:</strong> Refunds processed within 7–10
              business days via the original payment method. Shipping costs are
              non-refundable unless the error was Zabali’s.
            </p>
            <p>
              <strong>Replacement Option:</strong> Retailers may opt for store
              credit or replacement (subject to availability).
            </p>

            <p>
              <strong>4. Process for Returns/Refunds</strong>
            </p>
            <p>
              Notify Zabali: Email support@zabali.com with order details +
              images/videos of the issue.
            </p>
            <p>
              Return Authorization: Zabali will provide a return label (if
              applicable).
            </p>
            <p>
              Inspection: Refund/replacement initiated after quality
              verification.
            </p>

            <p>
              <strong>5. Exceptions</strong>
            </p>
            <p>
              No returns for orders marked "Final Sale" or discounted over 20%.
            </p>
            <p>Fraudulent claims may result in account suspension.</p>

            <p>
              <strong>6. Contact Us</strong>
            </p>
            <p>📞 +91-7619786322 | 📧 zabaliofficial@gmail.com</p>
            <p>Business Hours: 10 AM–8 PM (Mon–Sat)</p>
          </>
        }
      />
    </>
  );
};

export default CancelOrder;
